export default __webpack_public_path__ + "b4a01bc74f50b9fbc3e6cb288ed6f504.png";